import { createContext } from "react";

export const SearchFilterContext = createContext();
